module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-261.e3fae413.svg";